<template>
  <div>
    <h1>{{ insert[lang].header }}</h1>

    <div v-if="$store.state.appIsStarting" class="loader1"></div>
    <div v-else>
      <div v-if="!$store.state.isAuth">
        <login-form/>
      </div>
      <div v-else class="pt-30">
        <prod-list :insert="insert[lang].prodList"/>
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from '@/components/LoginForm'
import ProdList from '@/components/ProdList'
import insert from '@/data/languages/CatalogViewData.js'
import useLang from '@/hooks/useLang'
import { define } from '@/data/globals.js'

export default {
  components: { LoginForm, ProdList },

  setup() {
    const { lang } = useLang()

    return { define, lang, insert }
  }
}
</script>
